import React from "react";
import { VStack } from "@chakra-ui/react";
import RiskReviewSection from "./RiskReviewSection";
import { sortBySequence } from "../../utils/riskReviewFormUtils";

const RiskReviewDynamicForm = ({ template, form, editable = false, requestId }) => {
  const {
    control,
    values,
    rules,
    formState: { errors },
  } = form;

  return (
    <VStack spacing={3} align="stretch">
      {sortBySequence(template?.sections || []).map((section) => (
        <RiskReviewSection
          key={section._id || section.code}
          section={section}
          control={control}
          values={values}
          rules={rules}
          errors={errors}
          editable={editable}
          requestId={requestId}
        />
      ))}
    </VStack>
  );
};

export default RiskReviewDynamicForm;
